import React, { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Segment, Message, Container, Header } from 'semantic-ui-react'
import Navbar from '../../Components/NavHeader'
import APIService from '../../Services/API/APIService'
const GuestCancelBooKing = () => {

    const [loading, setLoading] = useState(false)
    const { reference } = useParams()
    const [cancelBooking, setCancelBooking] = useState(null)



    const fetchData = useCallback(async (isSubscribed) => {
        try {
            const accessToken = sessionStorage.getItem('accessToken');
            if (!accessToken) {
                if (isSubscribed) {
                    setCancelBooking({ success: false, msg: 'unauthorized' })
                }
                return
            }

            setLoading(true)

            let response = await APIService.postData('/guest-house/cancel-guestbooking', {
                reference: reference
            })
            if(isSubscribed){

                setCancelBooking(response)
            }
            setLoading(false)
        } catch (error) {
            console.log(error);
            if (isSubscribed) {
                setCancelBooking({ success: false, msg: 'unauthorized' })
            }
            setLoading(false)
        }
    }, [reference])

    useEffect(() => {
        let isSubscribed = true
        fetchData(isSubscribed)
        return () => (isSubscribed = false)
    }, [reference, fetchData])

    return (
        <div>

            <Navbar />


            <Container fluid>
                <Segment loading={loading}>
                    {cancelBooking && (
                        <>


                            <Header></Header>

                            <Container textAlign='center' style={{ padding: '1.2em' }}>
                                <Message negative>

                                    {cancelBooking.success === false && cancelBooking.msg === 'failed' && (
                                        <Message.Header>Action Cannot Be Completed</Message.Header>
                                    )}

                                    {cancelBooking.success === true && cancelBooking.msg === 'cancelled' && (
                                        <Message.Header>Booking Cancelled</Message.Header>
                                    )}


                                </Message>
                            </Container>

                        </>
                    )}

                </Segment>
            </Container>




        </div>
    )
}

export default GuestCancelBooKing